import React from "react";
import FamilyLogo from "../assets/family.png";

export default function Header() {
  return (
    <div className="h-32 bg-blue-primary flex justify-evenly">
      <a href="/flyer-generator" className="">
        <div className="px-4 mt-10">
          <img className="w-56" src={FamilyLogo} />
        </div>
      </a>
      <div className="px-4 mt-12 text-white text-4xl">
        OneTrust Marketing Flyer Generator
      </div>
    </div>
  );
}
